/* eslint-disable no-prototype-builtins */
// Pure table/merge helpers extracted VERBATIM from commonUtility.js.
//
// Why: commonUtility imports componentsTransfomation, which statically imports
// every FusionCharts widget component. widgetService only needed create2DArray
// from it, but that single import dragged the entire charting stack into the
// initial bundle for any screen using widgetService helpers (TopNav, login,
// org listing). These helpers are dependency-free, so they live here as a leaf
// module; commonUtility re-exports them so existing importers are unaffected.

export const mergeByKeys = (keys, ...arrays) => {
	const array = [];
	const groups = new Map(); // key => [pos in array, [array, of, objects, with, the, same, key]]

	for (const i in arrays) {
		if (arrays[i]) {
			for (const j in arrays[i]) {
				if (Object.prototype.hasOwnProperty.call(arrays[i], j)) {
					const element = arrays[i][j];
					const keysArray = keys.split("-");
					const keyValues = keysArray.map(key => {
						return element[key];
					});
					const keyString = keyValues.join("-");
					if (groups.has(keyString)) {
						groups.get(keyString)[1].push(element);
					} else {
						array.push(element);
						groups.set(keyString, [array.length - 1, []]);
					}
				}
			}
		}
	}

	for (const group of groups) {
		if (group[1][1].length === 0) {
			// continue;
		}
		array[group[1][0]] = Object.assign.apply(Object, [{}, array[group[1][0]]].concat(group[1][1]));
	}

	return array;
};

export const mergeByKey = function(key) {
	const array = [];
	const groups = new Map(); // key => [pos in array, [array, of, objects, with, the, same, key]]
	for (let i = 1; i < arguments.length; i += 1) {
		if (arguments[i]) {
			for (let j = 0; j < arguments[i].length; j += 1) {
				const element = arguments[i][j];
				if (element.hasOwnProperty(key)) {
					const keyValue = element[key];
					if (groups.has(keyValue)) {
						groups.get(keyValue)[1].push(element);
					} else {
						array.push(element);
						groups.set(keyValue, [array.length - 1, []]);
					}
				} else {
					array.push(element);
				}
			}
		}
	}

	for (const group of groups) {
		if (group[1][1].length === 0) {
			// continue;
		}
		array[group[1][0]] = Object.assign.apply(Object, [{}, array[group[1][0]]].concat(group[1][1]));
	}

	return array;
};

export const getUniqueHeaders = function(arr, keys) {
	let headers = [];
	const uniqueHeaders = keys.length ? [...keys] : []; // this will make sure that uniqueHeaders will always have dimensions keywords first, to maintain result array order as code is written s.t. dimensions keyword will always come prior to metric keywords
	for (const i in arr) {
		if (Object.prototype.hasOwnProperty.call(arr, i)) {
			headers = headers.concat(Object.keys(arr[i]));
			headers.map(function(value) {
				if (uniqueHeaders.indexOf(value) < 0) {
					uniqueHeaders.push(value);
				}
				return headers;
			});
		}
	}
	return uniqueHeaders;
};

export const create2DArray = function(originalArray, keys, primarySort, primarySortOrder) {
	const result = [];
	const arr = JSON.parse(JSON.stringify(originalArray));
	for (const i in arr) {
		if (Object.prototype.hasOwnProperty.call(arr, i)) {
			for (const j in arr[i]) {
				if (Object.prototype.hasOwnProperty.call(arr[i], j)) {
					const uniqueKey = [];
					for (const k in keys) {
						if (Object.prototype.hasOwnProperty.call(keys, k)) {
							if (arr[i][j].hasOwnProperty(keys[k])) {
								uniqueKey.push(arr[i][j][keys[k]]);
							} else {
								uniqueKey.push("Not Found");
							}
							arr[i][j][keys.join("-")] = uniqueKey.join("-");
						}
					}
				}
			}
		}
	}
	let joinedArray = mergeByKey.apply(null, [].concat(keys.join("-")).concat(arr));

	if (primarySort) {
		joinedArray = joinedArray.sort((a, b) => {
			if (primarySortOrder === "ASCE") return a[primarySort] - b[primarySort];
			if (primarySortOrder === "DESC") return b[primarySort] - a[primarySort];
		});
	}

	if (keys.length > 1) {
		for (const i in joinedArray) {
			if (joinedArray[i].hasOwnProperty(keys.join("-"))) {
				delete joinedArray[i][keys.join("-")];
			}
		}
	}
	const headers = getUniqueHeaders(joinedArray, keys);
	result.push(headers);
	for (const i in joinedArray) {
		if (Object.prototype.hasOwnProperty.call(joinedArray, i)) {
			const row = [];
			for (const j in headers) {
				if (joinedArray[i].hasOwnProperty(headers[j])) {
					row.push(joinedArray[i][headers[j]]);
				} else {
					row.push("Not Found");
				}
			}
			result.push(row);
		}
	}
	return result;
};
